// import { DialogComponent } from '@theme/dialog';
// import { CartAddEvent } from '@theme/events';
//
// /**
//  * A custom element that manages a cart drawer.
//  *
//  * @extends {DialogComponent}
//  */
// class CartDrawerComponent extends DialogComponent {
//   connectedCallback() {
//     super.connectedCallback();
//     document.addEventListener(CartAddEvent.eventName, this.#handleCartAdd);
//   }
//
//   disconnectedCallback() {
//     super.disconnectedCallback();
//     document.removeEventListener(CartAddEvent.eventName, this.#handleCartAdd);
//   }
//
//   #handleCartAdd = () => {
//     if (this.hasAttribute('auto-open')) {
//       this.showDialog();
//     }
//   };
//
//   open() {
//     this.showDialog();
//
//     /**
//      * Close cart drawer when installments CTA is clicked to avoid overlapping dialogs
//      */
//     customElements.whenDefined('shopify-payment-terms').then(() => {
//       const installmentsContent = document.querySelector('shopify-payment-terms')?.shadowRoot;
//       const cta = installmentsContent?.querySelector('#shopify-installments-cta');
//       cta?.addEventListener('click', this.closeDialog, { once: true });
//     });
//   }
//
//   close() {
//     this.closeDialog();
//   }
// }
//
// if (!customElements.get('cart-drawer-component')) {
//   customElements.define('cart-drawer-component', CartDrawerComponent);
// }



// cart-drawer.js
import { DialogComponent } from '@theme/dialog';
import { CartAddEvent } from '@theme/events';

class CartDrawerComponent extends DialogComponent {
  connectedCallback() {
    super.connectedCallback();
    document.addEventListener(CartAddEvent.eventName, this.#handleCartAdd);
    document.addEventListener('cart:updated', this.#handleCartUpdate);
  }

  disconnectedCallback() {
    super.disconnectedCallback();
    document.removeEventListener(CartAddEvent.eventName, this.#handleCartAdd);
    document.removeEventListener('cart:updated', this.#handleCartUpdate);
  }

  async refresh() {
    try {
      const [cartResponse, sectionResponse] = await Promise.all([
        fetch('/cart.js'),
        this.getSectionResponse()
      ]);
      
      if (cartResponse.ok) {
        const cartData = await cartResponse.json();
        
        window.cart = cartData;
        if (window.Shopify && window.Shopify.cart) {
          Object.assign(window.Shopify.cart, cartData);
        }
        
        if (sectionResponse) {
          await this.updateCartDialogWithHTML(sectionResponse, cartData);
        } else {
          await this.updateCartDialog();
        }

        // Re-initialize upsell functionality after cart refresh
        this.initializeUpsell();
      }
    } catch (e) {
      console.warn('Cart refresh failed', e);
    }
  }

  async getSectionResponse() {
    try {
      const sectionId = this.getAttribute('data-section-id');
      if (!sectionId) return null;
      
      const response = await fetch(`/sections/cart-drawer?section_id=${sectionId}`);
      return response.ok ? await response.text() : null;
    } catch (e) {
      return null;
    }
  }

  async updateCartDialogWithHTML(html, cartData = null) {
    try {
      const cartDialog = this.querySelector('.cart-drawer__inner');
      if (!cartDialog) return;
      
      const parser = new DOMParser();
      const doc = parser.parseFromString(html, 'text/html');
      const newCartDialog = doc.querySelector('.cart-drawer__inner');
      
      if (newCartDialog) {
        cartDialog.outerHTML = newCartDialog.outerHTML;
        await this.updateCartBubble(cartData);
      }
    } catch (e) {
      console.error('Cart dialog update with HTML failed', e);
    }
  }

  async updateCartDialog() {
    try {
      const cartDialog = this.querySelector('.cart-drawer__inner');
      if (!cartDialog) {
        return;
      }
      
      const sectionId = this.getAttribute('data-section-id');
      if (!sectionId) {
        return;
      }
      
      const response = await fetch(`/sections/cart-drawer?section_id=${sectionId}`);
      if (response.ok) {
        const html = await response.text();
        
        const parser = new DOMParser();
        const doc = parser.parseFromString(html, 'text/html');
        const newCartDialog = doc.querySelector('.cart-drawer__inner');
        
        if (newCartDialog) {
          cartDialog.outerHTML = newCartDialog.outerHTML;
          await this.updateCartBubble();
        }
      }
    } catch (e) {
      console.error('Cart dialog update failed', e);
    }
  }

  async updateCartBubble(cartData = null) {
    try {
      const cartBubble = document.querySelector('.cart-bubble');
      if (!cartBubble) {
        return;
      }
      
      let itemCount;
      if (cartData) {
        itemCount = cartData.item_count;
      } else {
        const cartResponse = await fetch('/cart.js');
        if (cartResponse.ok) {
          const freshCartData = await cartResponse.json();
          itemCount = freshCartData.item_count;
        } else {
          return;
        }
      }
      
      const cartBubbleCount = cartBubble.querySelector('.cart-bubble__text');
      if (cartBubbleCount) {
        cartBubbleCount.textContent = itemCount;
      }
      
      const visuallyHidden = cartBubble.querySelector('.visually-hidden');
      if (visuallyHidden) {
        visuallyHidden.textContent = `Кількість товарів в кошику: ${itemCount}`;
      }
      
      if (itemCount > 0) {
        cartBubbleCount.classList.remove('hidden');
        cartBubble.classList.remove('visually-hidden');
      } else {
        cartBubbleCount.classList.add('hidden');
        cartBubble.classList.add('visually-hidden');
      }
    } catch (e) {
      console.error('Cart bubble update failed', e);
    }
  }

  #handleCartAdd = async () => {
    if (this.hasAttribute('auto-open')) {
      this.showDialog();
      this.refresh();
    }
  };

  #handleCartUpdate = async () => {
    await this.refresh();
  };

  async open() {
    this.showDialog();
    this.refresh();

    // Initialize upsell when the cart drawer is opened
    this.initializeUpsell();

    // Existing code for installments CTA
    customElements.whenDefined('shopify-payment-terms').then(() => {
      const installmentsContent = document.querySelector('shopify-payment-terms')?.shadowRoot;
      const cta = installmentsContent?.querySelector('#shopify-installments-cta');
      cta?.addEventListener('click', this.closeDialog, { once: true });
    });
  }

  close() {
    this.closeDialog();
  }

  initializeUpsell() {
    const addToCartButtons = document.querySelectorAll('.cart_upsell_drawer');
    
    addToCartButtons.forEach(btn => {
      btn.addEventListener('click', function() {
        const productItem = btn.closest('.product-item-cart');
        const variantId = productItem.getAttribute('data-variant-id');
        const quantity = 1;
        const addText = btn.querySelector('.add-text');

        addText.classList.add("loading");
        const originalText = addText.textContent;
        addText.textContent = "Adding...";

        fetch("/cart/add.js", {
          method: "POST",
          headers: {
            "Content-Type": "application/json"
          },
          body: JSON.stringify({
            id: variantId,
            quantity: quantity
          })
        })
        .then(res => res.json())
        .then(() => {
          addText.textContent = "Added ✓";
          addText.classList.remove("loading");

          setTimeout(() => {
            addText.textContent = originalText;
          }, 2000);

          document.dispatchEvent(new CustomEvent("cart:updated"));
        })
        .catch(() => {
          addText.textContent = 'Error ❌';
          setTimeout(() => {
            addText.textContent = 'Add to Cart';
          }, 2000);
        });
      });
    });

    // Initialize Swiper for the upsell sliders
    this.initializeSwiper();
  }

  // Swiper initialization function
  initializeSwiper() {
    const swiperContainers = document.querySelectorAll('.upsell_swiper_container_cart');

    swiperContainers.forEach(container => {
      const productItems = container.querySelectorAll('.swiper-slide');
      
      if (productItems.length > 1) {
        new Swiper(container, {
          slidesPerView: '1.2',
          spaceBetween: 10,
          loop: true,
        });
      }
    });
  }
}

if (!customElements.get('cart-drawer-component')) {
  customElements.define('cart-drawer-component', CartDrawerComponent);
}


